export const SETUP_EVIDENCE_LABELS = {
  accountName: 'Account name',
  propertyName: 'Property name',
  propertyCountry: 'Property country',
  abnVerified: 'ABN verified',
  hotelAccountCurrency: 'Hotel account currency',
  opportunityCurrency: 'Opportunity currency',
  excludedBrands: 'Excluded brands',
  excludedCountries: 'Excluded countries',
  loadedScheduleRows: 'Loaded schedule rows',
  canonicalPropertyChain: 'Salesforce parent account',
  contractTemplateId: 'Contract template ID',
  leContractsGeo: 'LE Contracts Geo',
  sellCurrency: 'Sell currency',
  costCurrency: 'Cost currency',
  reportingCurrency: 'Reporting currency',
  packageCurrencies: 'Package currencies',
} as const;
